var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data"},[_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("../../assets/img/no_data.png"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }